import { useNavigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import AddEmployeeToProcess from 'modules/tasks/components/AddEmployeeToProcess'

const ImportPage = () => {
  const { navigation } = useNavigation()

  const { currentUserId } = useOutletContext<{ currentUserId: number }>()
  const { id } = useStrictParams<'id'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.employees.id.tasks.fullPath({ id }))
  }

  return <AddEmployeeToProcess currentUserId={currentUserId} onClose={onClose} />
}

export default ImportPage
